/**
 * Regular expression that represents the "/Metric:Value" path segment of a CVSS vector string.
 */
export const regexCvssVectorStringPathSegment = /\/\w{1,3}:\w{1,3}/i;
/**
 * Regular expression that can be use to validate a CVSS vector string.
 *
 * @example ```typescript
 * regexCvssVectorString.test('CVSS:3.0/AV:N/AC:L/PR:N/UI:N/S:U/C:N/I:N/A:N');
 * //> true
 * ```
 */
export const regexCvssVectorString = /CVSS:(\d+.\d+)(\/\w{1,3}:\w{1,3}){3,}/i;
